"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contact = exports.ContactUseAsEnum = void 0;
const typeorm_1 = require("typeorm");
const account_1 = require("./account");
const email_1 = require("./email");
const opportunity_option_1 = require("./opportunity-option");
const decorators_1 = require("../data-ui/decorators");
const contact_profile_enum_1 = require("./contact-profile-enum");
const layouts_1 = require("../data-ui/layouts");
const api_id_1 = require("../util/api-id");
const enums_1 = require("../data-ui/enums");
const address_1 = require("./address");
const job_1 = require("./job");
const product_order_1 = require("./product-order");
const contact_profile_1 = require("./contact-profile");
const partner_admin_watchlist_1 = require("./partner-admin-watchlist");
var ContactUseAsEnum;
(function (ContactUseAsEnum) {
    ContactUseAsEnum["DEFAULT"] = "Default";
    ContactUseAsEnum["INVOICE"] = "Invoice";
    ContactUseAsEnum["RECEIVE"] = "Receive";
})(ContactUseAsEnum = exports.ContactUseAsEnum || (exports.ContactUseAsEnum = {}));
let Contact = class Contact {
    updateApiId() {
        this.apiId = (0, api_id_1.makeApiId)();
    }
};
Contact.SFID_PREFIX = '003';
__decorate([
    decorators_1.DataUi.SearchField(),
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    decorators_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.Index)('gid_idx_contact_sfid'),
    (0, typeorm_1.PrimaryColumn)({
        type: 'character varying',
        length: 18,
        name: 'sfid',
        default: () => "gid_generate_sfid('003')",
    }),
    __metadata("design:type", String)
], Contact.prototype, "id", void 0);
__decorate([
    decorators_1.DataUi.SearchField(),
    decorators_1.DataUi.Override({ generated: true, length: 64 }),
    (0, typeorm_1.Index)('gid_idx_contact_api_id__c'),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
        unique: true,
        name: 'api_id__c',
    }),
    __metadata("design:type", String)
], Contact.prototype, "apiId", void 0);
__decorate([
    (0, typeorm_1.BeforeInsert)(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Contact.prototype, "updateApiId", null);
__decorate([
    decorators_1.DataUi.Override({ length: 100, readOnly: true }),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
        name: 'password__c',
    }),
    __metadata("design:type", String)
], Contact.prototype, "password", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: false,
        name: 'salutation',
        default: '',
        length: 40,
    }),
    __metadata("design:type", String)
], Contact.prototype, "salutation", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        name: 'title',
        length: 128,
    }),
    __metadata("design:type", String)
], Contact.prototype, "title", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        name: 'position__c',
        length: 255,
    }),
    __metadata("design:type", String)
], Contact.prototype, "position", void 0);
__decorate([
    decorators_1.DataUi.SearchField(),
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)('hc_idx_contact_firstname'),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 40,
        name: 'firstname',
    }),
    __metadata("design:type", String)
], Contact.prototype, "firstName", void 0);
__decorate([
    decorators_1.DataUi.SearchField(),
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)('hc_idx_contact_lastname'),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 80,
        name: 'lastname',
    }),
    __metadata("design:type", String)
], Contact.prototype, "lastName", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 121,
        nullable: true,
        name: 'name',
    }),
    __metadata("design:type", String)
], Contact.prototype, "name", void 0);
__decorate([
    decorators_1.DataUi.SearchField(),
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)('hc_idx_contact_email'),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 80,
        name: 'email',
    }),
    __metadata("design:type", String)
], Contact.prototype, "email", void 0);
__decorate([
    decorators_1.DataUi.SearchField(),
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)('hc_idx_contact_phone'),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 40,
        name: 'phone',
    }),
    __metadata("design:type", String)
], Contact.prototype, "phone", void 0);
__decorate([
    decorators_1.DataUi.SearchField(),
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)('hc_idx_contact_mobilephone'),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 40,
        name: 'mobilephone',
    }),
    __metadata("design:type", String)
], Contact.prototype, "mobilePhone", void 0);
__decorate([
    decorators_1.DataUi.Override({ readOnly: true, isCascadeRelation: false }),
    (0, typeorm_1.OneToMany)(() => contact_profile_1.ContactProfile, (profile) => profile.contact, {
        cascade: true,
    }),
    __metadata("design:type", Array)
], Contact.prototype, "profiles", void 0);
__decorate([
    decorators_1.DataUi.EnumValues(enums_1.LOCALES),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
        name: 'language__c',
    }),
    __metadata("design:type", String)
], Contact.prototype, "language", void 0);
__decorate([
    decorators_1.DataUi.Override({ readOnly: true }),
    (0, typeorm_1.Index)('hc_idx_contact_access_to_web_app_requested__c'),
    (0, typeorm_1.Column)('boolean', {
        name: 'access_to_web_app_requested__c',
        default: false,
        nullable: false,
    }),
    __metadata("design:type", Boolean)
], Contact.prototype, "accessToWebAppRequested", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.ManyToOne)(() => account_1.Account, (account) => account.contacts),
    (0, typeorm_1.JoinColumn)({ name: 'accountid' }),
    __metadata("design:type", account_1.Account)
], Contact.prototype, "account", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.ManyToOne)(() => opportunity_option_1.OpportunityOption, (opportunities) => opportunities.brandContacts),
    __metadata("design:type", opportunity_option_1.OpportunityOption)
], Contact.prototype, "opportunityOption", void 0);
__decorate([
    decorators_1.DataUi.Override({ isFilter: false }),
    (0, typeorm_1.Index)('hc_idx_contact_accountid'),
    decorators_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Column)('character varying', {
        length: 18,
        name: 'accountid',
    }),
    __metadata("design:type", String)
], Contact.prototype, "accountId", void 0);
__decorate([
    (0, typeorm_1.Column)((type) => address_1.MailingAddress, {
        prefix: '',
    }),
    __metadata("design:type", address_1.MailingAddress)
], Contact.prototype, "mailingAddress", void 0);
__decorate([
    decorators_1.DataUi.EnumValues(['Default', 'Invoice', 'Receive']),
    (0, typeorm_1.Index)('hc_idx_contact_use_as__c'),
    (0, typeorm_1.Column)({
        type: 'enum',
        default: ContactUseAsEnum.DEFAULT,
        nullable: false,
        name: 'use_as__c',
        enum: ContactUseAsEnum,
    }),
    __metadata("design:type", String)
], Contact.prototype, "useAs", void 0);
__decorate([
    (0, typeorm_1.Index)('hc_idx_contact_ispersonaccount'),
    (0, typeorm_1.Column)({
        type: 'boolean',
        nullable: true,
        name: 'ispersonaccount',
    }),
    __metadata("design:type", Boolean)
], Contact.prototype, "isPersonAccount", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'boolean',
        nullable: true,
        name: 'qualifications__c',
    }),
    __metadata("design:type", Boolean)
], Contact.prototype, "qualifications", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'boolean',
        nullable: true,
        name: 'isdeleted',
    }),
    __metadata("design:type", Boolean)
], Contact.prototype, "isDeleted", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'boolean',
        nullable: true,
        name: 'anonymized__c',
    }),
    __metadata("design:type", Boolean)
], Contact.prototype, "anonymized", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        nullable: true,
        length: 80,
        name: 'department',
    }),
    __metadata("design:type", String)
], Contact.prototype, "department", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: 'createddate',
        nullable: false,
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], Contact.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.Index)('gid_idx_contact_lastmodifieddate'),
    (0, typeorm_1.UpdateDateColumn)({
        name: 'lastmodifieddate',
        nullable: false,
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], Contact.prototype, "updatedAt", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.ManyToMany)(() => email_1.Email, (email) => email.contacts),
    __metadata("design:type", Array)
], Contact.prototype, "emails", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => job_1.Job, (job) => job.partnerInstallerContact),
    __metadata("design:type", Array)
], Contact.prototype, "installedJobs", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => product_order_1.ProductOrder, (order) => order.createdByContact),
    __metadata("design:type", Array)
], Contact.prototype, "productOrders", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => partner_admin_watchlist_1.PartnerAdminWatchlist, (watchlist) => watchlist.admin),
    __metadata("design:type", Array)
], Contact.prototype, "watchlist", void 0);
Contact = __decorate([
    decorators_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
    }),
    decorators_1.DataUi.Name({
        name: 'Contact',
        nameProperties: ['firstName', 'lastName'],
    }),
    decorators_1.DataUi.Actions(['loginAsUser']),
    decorators_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Index)('index_email_account_unique', ['email', 'accountId', 'useAs'], {
        unique: true,
        where: 'email is not null',
    }),
    (0, typeorm_1.Entity)('contact', { schema: 'public', synchronize: true })
], Contact);
exports.Contact = Contact;
//# sourceMappingURL=contact.js.map